














import Vue from "vue";
import { CellControllerImpl } from "../../services/cellcontroller";
import InputCell from "./InputCell.vue";
import { Cell } from "../../services/vo";
import {
  CellPosition,
  SelectCell,
  InputCell as InputCellI,
  DomCell,
} from "vue/types/vue";
import { PuzzleData } from "../../services/vo/puzzledata";
import { addKeyPressObserver } from "../../services/inputservice";

const X = 0;
const Y = 1;
const CONTROL = 2;

export default Vue.extend({
  name: "PlayArea",
  components: {
    InputCell,
  },
  props: {
    puzzleData: Object as () => PuzzleData,
    readOnly: {
      type: Boolean,
      default: false,
    },
    solution: {
      type: Array as () => Array<string>,
      default: () => Array<string>(),
    },
  },
  data() {
    return {
      selectedCell: new Cell({ x: -1, y: -1 }, "1"),
      direction: "h",
      markedCells: new Array<Cell>(),
      cells: new Array<Array<Cell>>(),
      cellWidth: "0",
      cellHeight: "0",
      gridWidth: 0,
      gridHeight: 0,
      width: 0,
      height: 0,
      playState: "",
    };
  },
  inject: {
    inputMode: {
      from: "INPUT_MODE",
      default: 'none'
    }
  },
  mounted() {
    this.setNumbers();
    this.setArrows();
    this.setDashes();
    if (this.solution.length > 0) {
      this.toggleSolution(this.solution);
    }


    addKeyPressObserver(this.action);
  },
  created() {
    this.selectedCell = this.newEmptyCell();
    this.width = this.puzzleData.getWidth();
    this.height = this.puzzleData.getHeight();

    this.setBoardSize();
    this.setAllCells();
    this.deselect();

    //this.boardData = this.puzzleData.data;
  },
  // inject: ["keyboardPress"],
  computed: {
    currentCell: function (): Cell {
      if (this.selectedCell.isValid()) {
        return this.selectedCell;
      } else {
        return this.newEmptyCell();
      }
    },
    allCells: function (): Cell[] {
      let all: Cell[] = new Array<Cell>();

      for (let i = 0; i < this.cells.length; i++) {
        all = all.concat(this.cells[i]);
      }

      return all;
    },
    liClass: function () {
      return {};
    },
    cellStyle: function (): any {
      return {
        width: this.cellWidth,
        height: this.cellHeight,
        "font-size": "10px",
      };
    },
    boardFilled: function (): boolean {
      const cells: Array<Cell> = this.allCells;
      for (const c of cells) {
        if (c.isSelectable() && c.getLetter() === "") {
          return false;
        }
      }
      return true;
    },
  },
  methods: {
    newEmptyCell: function (): Cell {
      return new Cell({ x: -1, y: -1 }, "1");
    },
    getAllCells: function (): Cell[] {
      let all: Cell[] = new Array<Cell>();

      for (let i = 0; i < this.cells.length; i++) {
        all = all.concat(this.cells[i]);
      }

      return all;
    },
    createCell(col: number, row: number): Cell {
      const pos: CellPosition = {
        x: col as number,
        y: row as number,
      };
      const cellState = this.puzzleData.state[row][col];
      return new Cell(pos, cellState);
    },
    deselect(): void {
      //this.selectedCell = this.emptyCell;
      this.select();
      this.markBoard();
    },
    setAllCells: function () {
      this.cells = new Array<Cell[]>();
      for (let row = 0; row < this.height; row++) {
        this.cells[row] = new Array<Cell>();
        for (let col = 0; col < this.width; col++) {
          const cell = this.createCell(col, row);
          this.cells[row].push(cell);
        }
      }
    },
    setMarkedCells: function (cells: Cell[]): void {
      this.markedCells = cells;
    },
    setNumbers: function (): void {
      const words = this.puzzleData.wordStarts;
      for (let pos: number = 0; pos < words.length; pos++) {
        const row: number = words[pos].x;
        const col: number = words[pos].y;
        this.getCell(row, col).setStart((pos + 1).toString());
      }
    },
    setArrows: function (): void {
      const arrows = this.puzzleData.arrows;
      for (let pos in arrows) {
        for (let pos in arrows) {
          const x = arrows[pos].x;
          const y = arrows[pos].y;
          const dir = arrows[pos].direction;
          this.getCell(x, y).setArrow(dir);
        }
      }
    },
    setDashes: function (): void {
      const dashes = this.puzzleData.dashes;
      for (let pos in dashes) {
        const x = dashes[pos].x;
        const y = dashes[pos].y;
        const dir = dashes[pos].direction;
        this.getCell(x, y).setDash(dir);
      }
    },
    addDOM: function (cell: DomCell): void {
      this.getCell(cell.x, cell.y).setDom(cell.dom);
    },

    selectCell: function (payload: SelectCell): void {
      this.select(payload.cell, payload.dir);
    },
    select: function (
      cell: Cell | undefined = undefined,
      dir: boolean = false
    ): void {
      if (cell === undefined) {
        cell = this.newEmptyCell();
      }

      if (dir && this.selectedCell === cell) {
        this.toggleDirection();
      }
      try {
        if (this.currentCell.isValid()) {
          this.currentCell.getDom().blur();
          this.currentCell.getDom().deselect();
        }
        this.selectedCell = cell;
        if (this.currentCell.isValid()) {
          this.currentCell.getDom().focus();
          this.currentCell.getDom().select();
          this.markBoard();
        }
      } catch (error: any) {
        console.log(error);
      }
    },
    findNextCell: function (operation: string, direction?: string): Cell {
      let valid: Cell = this.currentCell;

      let op = operation;

      const pos: CellPosition = this.currentCell.getPos();
      let x: number = pos.x;
      let y: number = pos.y;
      let next: Cell = this.nextCell(this.getCell(x, y), op, direction);
      let nextFound: boolean = false;
      let c = 0;
      const cellCount = this.width * this.height;
      while (!nextFound && c < cellCount) {
        if (next && next.isValid()) {
          valid = next;
        }
        if (!next.isValid()) {
          next = this.nextRow(valid, op, direction);
        } else if (!next.getDom().isSelectable) {
          next = this.nextCell(next, op, direction);
        }
        c++;
      }
      return valid;
    },
    inputLetter: function (payload: string[]): void {
      for (const letter of payload) {
        if (CellControllerImpl.validLetter(letter)) {
          this.currentCell.setLetter(letter.toUpperCase());
          this.$emit("filled", this.boardFilled);
          this.moveNextCell();
        }
      }
    },
    markBoard: function (): void {
      this.markedCells = new Array<Cell>();
      let marked: Cell[] = new Array<Cell>();
      if (!this.selectedCell.isValid()) {
        return;
      }
      let sel: Cell = this.selectedCell;
      let curr: Cell = this.nextCell(sel, "+");
      while (curr.isValid()) {
        if (!curr.getDom().isSelectable) {
          break;
        }
        marked.push(curr);
        curr = this.nextCell(curr, "+");
      }
      curr = this.nextCell(sel, "-");
      while (curr.isValid()) {
        if (
          !this.getCell(curr.getPos().x, curr.getPos().y).getDom().isSelectable
        ) {
          break;
        }
        marked.push(curr);
        curr = this.nextCell(curr, "-");
      }
      this.setMarkedCells(marked);
      // console.log(this.markedCells);
    },
    nextCell: function (cell: Cell, op: string, direction?: string): Cell {
      let dir = this.direction;
      if (direction) {
        dir = direction;
      }
      let cx = cell.getPos().x;
      let cy = cell.getPos().y;
      let x = cell.getPos().x;
      let y = cell.getPos().y;
      switch (op) {
        case "+":
          x = dir === "h" ? cx + 1 : cx;
          y = dir === "v" ? cy + 1 : cy;
          break;
        case "-":
          x = dir === "h" ? cx - 1 : cx;
          y = dir === "v" ? cy - 1 : cy;
          break;
      }
      const next: Cell = this.getCell(x, y);
      return next; //this.cells[y][x];
    },
    nextRow: function (cell: Cell, op: string, direction?: string): Cell {
      let dir = this.direction;
      if (direction) {
        dir = direction;
      }
      let x = cell.getPos().x;
      let y = cell.getPos().y;
      if (this.gridStartOrEnd(cell)) {
        return this.currentCell;
      }
      switch (dir) {
        case "h":
          if (op === "+") {
            x = 0;
            y++;
          } else if (op === "-") {
            x = this.width - 1;
            y--;
          }
          break;
        case "v":
          if (op === "+") {
            x++;
            y = 0;
          } else if (op === "-") {
            y = this.height - 1;
            x--;
          }
          break;
      }
      return this.getCell(x, y);
    },
    moveNextCell: function (direction?: string): void {
      const next = this.findNextCell("+", direction);
      this.select(next);
    },
    movePreviousCell: function (direction?: string): void {
      const next = this.findNextCell("-", direction);
      this.select(next);
    },
    action: function (key: string) {

      if (
        document.activeElement?.tagName === "TEXTAREA" ||
        document.activeElement?.classList.contains("text-input") ||
        document.activeElement?.id.startsWith("song-input")
      ) {
        return;
      }

      if (!this.selectedCell.isValid()) return;

      const activeElementClasses: DOMTokenList | undefined =
        document.activeElement?.classList;
      //if (!activeElementClasses?.contains("key")) return;

      switch (key) {
        case "backspace": //Backspace
          //TODO: BackSpace()
          if (this.currentCell.getDom().letter !== "") {
            this.currentCell.getDom().letter = "";
          } else {
            this.movePreviousCell();
            this.currentCell.getDom().letter = "";
          }
          break;

        case "arrowleft": //Left
          //TODO: MoveLeft()
          this.movePreviousCell("h");

          break;
        case "arrowup": //Up
          //TODO: MoveUp()
          this.movePreviousCell("v");

          break;
        case "arrowright": //Right
          //TODO: MoveRight()
          this.moveNextCell("h");
          break;
        case "arrowdown": //Down
          //TODO: MoveDown()
          this.moveNextCell("v");
          break;
        case " ": //Space
          this.toggleDirection();
          break;

        default:
          this.inputLetter([key]);
          break;
      }
      this.$emit("filled", this.boardFilled);
    },
    getCell: function (x: number, y: number): Cell {
      try {
        const cell = this.cells[y][x];
        if (!cell) {
          throw "not a cell";
        }
        return cell;
      } catch (error: any) {
        return this.newEmptyCell();
      }
    },
    gridStartOrEnd: function (cell: Cell): boolean {
      const pos: CellPosition = cell.getPos();
      const x: number = pos.x;
      const y: number = pos.y;
      return (
        (x === 0 && y === 0) || (x === this.width - 1 && y === this.height - 1)
      );
    },
    toggleDirection: function () {
      this.direction = this.direction === "h" ? "v" : "h";
    },
    unmarkAll: function () {
      for (let cell of this.allCells) {
        cell.getDom().unmark();
      }
    },
    reset: function () {
      for (let i = 0; i < this.height; i++) {
        for (let j = 0; j < this.width; j++) {
          this.getCell(j, i).getDom().letter = "";
        }
      }
      this.deselect();
      this.markBoard();
    },
    send: async function (): Promise<void> {
      let gameData: string = "";
      for (let i = 0; i < this.height; i++) {
        for (let j = 0; j < this.width; j++) {
          gameData += this.getCell(i, j).getDom().letter;
        }
      }

      //return this.$store.dispatch("send", gameData);
    },
    clicked: function (cell: Cell): void {
      if (!this.readOnly) {
        this.$emit("clicked", cell);
      }
    },
    setBoardSize: function (): void {
      this.cellWidth = 100 + "%";
      this.cellHeight = 100 + "%";
    },
    toggleSolution: async function (solution: string[]): Promise<void> {
      try {
        const cells = this.allCells;
        //console.log(cells);
        for (let cell of cells) {
          if (!cell.getDom().isSelectable) {
            continue;
          } else {
            let letter = solution.splice(0, 1)[0];
            if (letter === "_") letter = "";
            cell.getDom().letter = letter;
          }
        }
        this.deselect();
      } catch (error: any) {
        console.log(error);
        this.reset();
      }
    },

  },
  watch: {
    markedCells: function (val, old): void {
      this.unmarkAll();

      for (let i = 0; i < val.length; i++) {
        let cell = val[i];
        cell.getDom().mark();
      }
    },
    direction: function (): void {
      this.markBoard();
    },
  },
});
